<template>
  <div class="main">
    <div class="head">
      <div class="title">MOVE 上海市职工健康服务平台</div>
    </div>
    <div class="con">
      <div class="left">
        <div class="top">
          <left-top :all_user="all_user" :today_user="today_user" :last_week_user="last_week_user" :week_user="week_user" />
        </div>
        <!-- <div class="middle">
          <div class="c-title">运动设备使用时长</div>
          <left-middle v-if="devices.length" :cData="devices" />
        </div> -->
        <div class="bottom">
          <div class="c-title">运动设备使用频次</div>
          <left-bottom v-if="devices.length" :list="devices" :count="5" />
        </div>
      </div>
      <div class="center">
        <div class="top">
          <center-top />
        </div>
        <div class="bottom">
          <div class="c-title">驿站一览</div>
          <center-bottom />
        </div>
      </div>
      <div class="right">
        <div class="top">
          <div class="c-title">
            <!-- 线上运动情况 <span>参与工会：{{ group_num }}</span> -->
            线上运动 <span>参与工会：81</span>
          </div>
          <right-top :day_num="day_num" :week_num="week_num" :month_num="month_num" />
        </div>
        <div class="middle">
          <div class="c-title">工会排行榜</div>
          <right-middle v-if="zryGroupRank_r.length" :list1="zryGroupRank_r" :list2="zryGroupRank_z" :list3="zryGroupRank_y" />
        </div>
        <div class="bottom">
          <div class="c-title">个人排行榜</div>
          <right-bottom
            v-if="day_people_rank.list.length"
            :list1="day_people_rank.list"
            :list2="week_people_rank.list"
            :list3="month_people_rank.list"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

import leftTop from './left-top.vue'
import leftMiddle from './left-middle.vue'
import leftBottom from './left-bottom.vue'

import centerTop from './center-top.vue'
import centerBottom from './center-bottom.vue'

import rightTop from './right-top.vue'
import rightMiddle from './right-middle.vue'
import rightBottom from './right-bottom.vue'

export default {
  components: { leftTop, leftMiddle, leftBottom, centerTop, centerBottom, rightTop, rightMiddle, rightBottom },
  data() {
    return {
      // left-top
      today_user: 0,
      all_user: 0,
      week_user: 0,
      last_week_user: 0,
      // left-middle, left-bottom
      devices: [],

      // right-top
      day_num: 0,
      week_num: 0,
      month_num: 0,
      group_num: 0,
      // right-middle
      zryGroupRank_r: [],
      zryGroupRank_z: [],
      zryGroupRank_y: [],
      // right-bottom
      day_people_rank: {},
      week_people_rank: {},
      month_people_rank: {},
    }
  },
  mounted() {
    this.get_data()

    itimer = setInterval(() => {
      this.get_data()
    }, 60000)
  },
  methods: {
    get_data() {
      const query = this.$route.query
      api.common.yundongData({ ...query, gid: 'eStBcUhqZ0ZvRE09' }).then((r) => {
        r.data.devices.forEach((row) => {
          let str = row.sport_time
          let hour = ''
          let minute = ''

          if (str) {
            hour = str.match(/(\S*)h/)[1]
            minute = str.match(/h (\S*)m/)[1]
          }

          row.time = hour * 60 + minute * 1
        })

        Object.keys(r.data).forEach((key) => {
          this[key] = r.data[key]
        })
      })

      api.common.dayWeekMonth({ ...query, gid: 'eStBcUhqZ0ZvRE09' }).then((r) => {
        Object.keys(r.data).forEach((key) => {
          this[key] = r.data[key]
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.main {
  padding: 0 42px;
  background: #001f5d;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  .head {
    width: 100%;
    height: 100px;
    background: url(../../../assets/gonghui/head-bg.png) no-repeat top center / 100% 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 8px;
    .title {
      font-size: 40px;
      font-weight: 500;
      margin-top: 12px;
      color: #b6d0ff;
      text-align: center;
    }
  }
  .con {
    display: flex;
    align-items: center;
    .c-title {
      padding: 10px 0px 16px;
      margin: 0 24px;
      font-size: 22px;
      color: #a5d4ff;
    }
    .left {
      .c-title {
        background: url(../../../assets/province/line-1.png) no-repeat center bottom / contain;
      }
      .top {
        width: 484px;
        height: 308px;
        background: url(../../../assets/yundong/left-top.png) no-repeat center center / 100% 100%;
      }
      // .middle {
      //   margin-top: 20px;
      //   width: 484px;
      //   height: 380px;
      //   background: url(../../../assets/yundong/left-middle.png) no-repeat center center / 100% 100%;
      // }
      .bottom {
        margin-top: 20px;
        width: 484px;
        height: 618px;
        background: url(../../../assets/yundong/left-bottom.png) no-repeat center center / 100% 100%;
      }
    }
    .center {
      padding: 0 20px;
      .c-title {
        background: url(../../../assets/province/line-2.png) no-repeat center bottom / contain;
      }
      .top {
        width: 828px;
        height: 465px;
        background: url(../../../assets/yundong/center-top.png) no-repeat center center / 100% 100%;
      }
      .bottom {
        width: 828px;
        height: 461px;
        margin-top: 20px;
        background: url(../../../assets/yundong/center-bottom.png) no-repeat center center / 100% 100%;
      }
    }
    .right {
      .c-title {
        background: url(../../../assets/province/line-1.png) no-repeat center bottom / contain;
      }
      .top {
        .c-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            font-size: 14px;
            color: #fff;
          }
        }
        width: 484px;
        height: 250px;
        background: url(../../../assets/yundong/right-top.png) no-repeat center center / 100% 100%;
      }
      .middle {
        width: 484px;
        height: 328px;
        margin-top: 20px;
        background: url(../../../assets/yundong/right-middle.png) no-repeat center center / 100% 100%;
      }
      .bottom {
        width: 484px;
        height: 328px;
        margin-top: 20px;
        background: url(../../../assets/yundong/right-bottom.png) no-repeat center center / 100% 100%;
      }
    }
  }
}
</style>
